import React from "react";
import QuillHtmlDisplay from "./QuillHtmlDisplay";
import DpatQaMemoTemplateView from "./DpatQaMemoTemplateView";

export function DpatQaMemoDocumentDisplay({ districtName, year, summary, addendumHtml }) {
  const addendum = (addendumHtml || "").trim();

  return (
    <div className="dpat-qa-memo-document">
      <DpatQaMemoTemplateView districtName={districtName} year={year} summary={summary} />
      {addendum ? (
        <div className="dpat-qa-memo-addendum-wrap" data-qa-memo-addendum="true">
          <QuillHtmlDisplay html={addendum} />
        </div>
      ) : null}
    </div>
  );
}

export default DpatQaMemoDocumentDisplay;
